
import { defineComponent } from "vue";
import buttons from "../components/button.vue";

export default defineComponent({
  name: "hero",
  components: {
    buttons,
  },
});
